import { render, staticRenderFns } from "./painel-secao-progresso.vue?vue&type=template&id=b6d3ace4&scoped=true&"
import script from "./painel-secao-progresso.vue?vue&type=script&lang=js&"
export * from "./painel-secao-progresso.vue?vue&type=script&lang=js&"
import style0 from "./painel-secao-progresso.vue?vue&type=style&index=0&id=b6d3ace4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d3ace4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d3ace4')) {
      api.createRecord('b6d3ace4', component.options)
    } else {
      api.reload('b6d3ace4', component.options)
    }
    module.hot.accept("./painel-secao-progresso.vue?vue&type=template&id=b6d3ace4&scoped=true&", function () {
      api.rerender('b6d3ace4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/painel-do-chat/painel-secao-progresso.vue"
export default component.exports